import { render, staticRenderFns } from "./PollQuestion.vue?vue&type=template&id=ec4a39a2&"
import script from "./PollQuestion.vue?vue&type=script&lang=js&"
export * from "./PollQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports